import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EUR = (v) => `${v.toFixed(2).replace(".", ",")} €`;

export async function createCheckout(pack, form) {
    const payload = {
        lookup_key: pack.lookupKey,
        quantity: 1,
        origin_url: window.location.origin,
        customer_name: form.name,
        customer_email: form.email,
        customer_phone: form.phone,
        shipping_address: form.address,
        shipping_postal: form.postal,
        shipping_city: form.city,
    };
    const { data } = await axios.post(`${API}/payments/checkout`, payload);
    return data;
}
